import { createFormatter } from 'pejer/src/helpers'
import { defaultTables, defaultUrls } from 'pejer/src/stores/config'
import { Config, ConfigUrls, TableConfig } from 'pejer/src/types/base'
import { CheckoutResponse, CheckoutVerifyPaymentResponse } from './types/checkout'
import { InvoiceCreationResponse, InvoiceDetails } from './types/invoice'
import { PaymentNotificationResponse } from './types/paymentNotificationDetails'

export const userTables = { ...defaultTables } satisfies TableConfig

const urls = {
  ...defaultUrls,
  invoice: {
    get: {
      path: '/payments/{paymentReferenceID}/invoice',
      method: 'GET',
      formatter: createFormatter<InvoiceDetails>(),
    },
  },
  paymentNotice: {
    get: {
      path: '/payments/{paymentReferenceID}/notices/{paymentNotificationID}',
      method: 'GET',
      formatter: createFormatter<PaymentNotificationResponse>(),
    },
  },
  checkout: {
    getPayment: {
      path: '/checkout/payment/{paymentReferenceID}',
      method: 'GET',
      formatter: createFormatter<CheckoutResponse>(),
    },
    createInvoice: {
      path: '/checkout/payment/{paymentReferenceID}/invoice',
      method: 'POST',
      formatter: createFormatter<InvoiceCreationResponse>(),
    },
    verifyPayment: {
      path: '/checkout/payment/{paymentReferenceID}/verify',
      method: 'GET',
      formatter: createFormatter<CheckoutVerifyPaymentResponse>(),
    },
    updateSwedbankPayInstrument: {
      path: '/checkout/payment/{paymentReferenceID}/swedbankpay',
      method: 'GET',
      formatter: createFormatter<{
        scriptUrl: string
      }>(),
    },
  },
  avtaleGiro: {
    getAvtaleGiro: {
      path: '/avtalegiro/{avtaleGiroOnboardingLinkID}',
      method: 'GET',
      formatter: createFormatter<{
        organizationID: string
        countryCode: string
        businessName: string
        isDirectPaymentAccount: boolean
        hasActiveAgreement: boolean
      }>(),
    },
    createAvtaleGiroAgreement: {
      path: '/avtalegiro/{avtaleGiroOnboardingLinkID}',
      method: 'POST',
      formatter: createFormatter<{
        shouldRedirectToAvtaleGiroSetup: boolean
        redirectBackUrl: string
        accountNumber: string
        countryCode: string
        organizationID: string
        kidReference: string
      }>(),
    },
  },
} as const satisfies ConfigUrls

export const config = {
  cookieNames: {},
  urls,
  schema: { tables: userTables },
  columns: {},
} satisfies Config<typeof urls, typeof userTables>
